<template>
  <div class="box">
    <HomerIntro />
    <HomeDesc />
  </div>
</template>

<script>
import HomerIntro from '@/components/legalDocuments/intro';
import HomeDesc from '@/components/legalDocuments/desc';

export default {
  name: 'MobileLegalDocuments',
  components: {
    HomerIntro,
    HomeDesc
  }
}
</script>

<style scoped lang="scss">
  .box{
      width: 100%;
      height: auto;
      padding-top: 44px;
      color: #000;
  }
</style>
